/**
 * Convierte un string SRT completo a texto plano (solo contenido)
 * Maneja tanto \n reales como \\n escapados
 */
export const parseSubtitlesToText = (srt: string): string => {
  if (!srt || typeof srt !== 'string') return '';

  const normalizedSRT = srt.replace(/\\n/g, '\n');

  return normalizedSRT
    .split('\n\n')
    .map(block => {
      const lines = block.split('\n');
      // Saltar número de secuencia (línea 0) y timestamp (línea 1)
      return lines.slice(2).join(' ');
    })
    .filter(text => text.trim())
    .join('\n\n');
};

/**
 * Reconstruye un SRT completo manteniendo timestamps originales
 * pero con nuevo contenido de texto
 */
export const rebuildSRT = (originalSRT: string, newText: string): string => {
  const normalizedSRT = originalSRT.replace(/\\n/g, '\n');

  const blocks = normalizedSRT.split('\n\n');
  const newLines = newText
    .split('\n\n')
    .map(l => l.trim())
    .filter(Boolean);

  return blocks
    .map((block, i) => {
      const lines = block.split('\n');
      if (lines.length >= 2 && newLines[i]) {
        // Mantener número (línea 0) y timestamp (línea 1)
        return `${lines[0]}\n${lines[1]}\n${newLines[i]}`;
      }
      return block;
    })
    .join('\n\n');
};
